import React, { FC, Fragment } from 'react';
import { Tooltip } from '@mui/material';
import { LabMaterial, MaterialBatch, PriceListMaterial } from 'models/material';
import { useTranslation } from 'react-i18next';

type MaterialBatcherTooltipProps = {
    material: PriceListMaterial | LabMaterial;
};
const MaterialBatcherTooltip: FC<MaterialBatcherTooltipProps> = ({ material }: MaterialBatcherTooltipProps) => {
    const { t: translate } = useTranslation();

    const numberOfOpenBatches = (batches?: MaterialBatch[]): number | undefined => {
        if (!batches) {
            return;
        }
        const openBatches = batches.filter((batch) => !batch.closed);
        if (!openBatches) {
            return;
        }
        return openBatches.length;
    };
    const tooltipTitle = (batches?: MaterialBatch[]): string => {
        const openBatches = batches?.filter((batch) => !batch.closed);
        if (openBatches?.length === 0) {
            return translate('actions-materials:NO_OPEN_BATCH');
        } else if (openBatches?.length === 1) {
            return openBatches?.length.toString() + ' ' + translate('actions-materials:OPEN_BATCH').toLowerCase();
        } else {
            return openBatches?.length.toString() + ' ' + translate('actions-materials:OPEN_BATCHES').toLowerCase();
        }
    };

    return (
        <Fragment>
            {material.batchInventoryManagement && (
                <Tooltip title={tooltipTitle(material.batches)}>
                    <div>{numberOfOpenBatches(material.batches)}</div>
                </Tooltip>
            )}
        </Fragment>
    );
};

export default MaterialBatcherTooltip;
